import { render, staticRenderFns } from "./CaricaFileSoggetto.vue?vue&type=template&id=46b801ef&scoped=true&"
import script from "./CaricaFileSoggetto.vue?vue&type=script&lang=js&"
export * from "./CaricaFileSoggetto.vue?vue&type=script&lang=js&"
import style0 from "./CaricaFileSoggetto.vue?vue&type=style&index=0&id=46b801ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b801ef",
  null
  
)

export default component.exports